function isBeginningOftheBlock(anchorOffset, focusOffset) {
  return anchorOffset === 0 && focusOffset === 0;
}

export default isBeginningOftheBlock;
